// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"dbe1bf34","53":"932a321b"}[chunkId] + ".chunk.css";
};